export default __webpack_public_path__ + "static/media/revitPianoCover.8de2237a.jpg";